export default __webpack_public_path__ + "static/media/qr-templated-seagas.16501c9b.png";